import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-mini-product-page',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map